// extracted by mini-css-extract-plugin
export default {"category":"HealthCare_category__UG1Qd"};